<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="我的积分" left-arrow fixed
                     @click-left="back"
        />
        <div class="integral-header">
            <van-circle
                    v-model="currentRate"
                    :rate="100"
                    :speed="0"
                    color="#fff"
                    size="120px"
                    layer-color="#fff"
                    :stroke-width="60"
            >
                <div class="circle-text">
                    <p>{{integral}}</p>
                    <span>可用积分</span>
                </div>
            </van-circle>
            <div class="integral-hdf">
                <van-row class="integral-hdf-bg">
                    <van-col span="12">
                        <a href="#/user/order/userIntegralRule">
                            <van-icon name="question-o"/>
                            如何赚积分
                        </a>
                    </van-col>
                    <van-col span="12">{{targetCount}}枚成就</van-col>
                </van-row>
            </div>
        </div>
        <van-row class="integral-fun">
            <van-col span="6" class="integral-fun-item" v-if="json.TARGET_MEMBER_CONFIG">
                <a href="#/user/order/userIntegralGet">
                <i class="iconfont icon-xunzhang bg-pink"></i>
                <p>会员成就</p>
                </a>
            </van-col>
            <van-col span="6" class="integral-fun-item">
                <a href="#/integral/home">
                    <i class="iconfont icon-jifenguizeguankong2"></i>
                    <p>积分商城</p></a>
            </van-col>
            <van-col span="6" class="integral-fun-item">
                <a href="#/user/integral/detail">
                    <i class="iconfont icon-mingxi bg-cyan"></i>
                    <p>积分明细</p></a>
            </van-col>
            <van-col span="6" class="integral-fun-item" v-if="json.SHARE_CONFIG">
                <a href="#/user/qrCode">
                <i class="iconfont icon-erweima bg-purple"></i>
                <p>会员码</p></a>
            </van-col>
        </van-row>
        <div class="integral-activity">
            <h5>会员活动</h5>
            <van-row>
                <!--    <van-col span="6" class="integral-fun-item" v-if="docEnable=='1'&&userRole=='BUYER'"> -->
                <van-col span="6" class="integral-fun-item" v-if="json.CHECKIN_CONFIG">
                    <a href="javascript:;"  @click="signIn">
                        <i class="iconfont icon-ziyuan"></i>
                        <p>签到</p>
                    </a>
                </van-col>
                <van-col span="6" class="integral-fun-item" v-if="json.GAME_CONFIG">
                    <a href="#/game/luck">
                        <i class="iconfont icon-shouye"></i>
                        <p>幸运抽奖</p>
                    </a>
                </van-col>
                <van-col span="6" class="integral-fun-item" v-if="json.ACTIVITY_CONFIG">
                    <a href="#/game/luckyDraw">
                        <i class="iconfont icon-shouye"></i>
                        <p>活动抽奖</p>
                    </a>
                </van-col>
                <van-col span="6" class="integral-fun-item" v-if="json.GAME_CONFIG">
                    <a href="#/game/egg">
                        <i class="iconfont icon-shouye"></i>
                        <p>砸金蛋</p>
                    </a>
                </van-col>
            </van-row>
        </div>
    </div>

</template>
<script>
    import {NavBar, Circle, Row, Col,Dialog} from "vant";

    export default {
        name: "userintegral",
        components: {
            [Dialog.name]: Dialog,
            [NavBar.name]: NavBar,
            [Circle.name]: Circle,
            [Row.name]: Row,
            [Col.name]: Col
        },
        data() {
            return {
                userRole: localStorage.getItem("userRole"),
                integral: "",
                currentRate: 0,
                selectedLogoPicture: '',
                targetCount: '',
                cumulative:'',
                extPoint:'',
                needContinuDays:'',
                nextContinuIntegral:'',
                docEnable:'',
                json:{}
            };
        },
        mounted() {
            let that = this;
            this.$api.get(that.jumuc.userCenter.getUserInfo, null,
                successRes => {
                    // console.log(successRes)
                    if (successRes.success) {
                        that.targetCount = successRes.data.targetCount
                        that.integral = successRes.data.user.integral
                    }
                })
               //判断签到的
            // this.$api.get(that.jumuc.userCenter.getConfigDocEnable, {"keyName":'CHECKIN_CONFIG'},
            //     successRes => {
            //         if (successRes.success) {
            //             that.docEnable=successRes.data.docEnable
            //         }
            //     })
                //积分配置项
                 this.$api.get(that.jumuc.userCenter.getConfigDocInfoEnable, null,
                successRes => {
                    if (successRes.success) {
                       this.json=successRes.data;
                    }
                })
        },
        methods: {
            back() {
                history.back();
            },
            toDetail() {
                location.href = "#/user/integral/detail"
            },
            signIn(){
                let that = this;
                this.$api.post(that.jumuc.integral.signIn, null,
                    successRes => {
                        if (successRes.success) {
//                            alert("签到成功！"+"您已连续签到："+jsonData.cumulative+" 天,额外赠送积分："+jsonData.point+"再连续登陆 :"+jsonData.needContinuDays+" 天，可额外获得积分: "+jsonData.nextContinuIntegral);
                            that.cumulative = successRes.data.cumulative;
                            that.extPoint = successRes.data.point;
                            that.needContinuDays = successRes.data.needContinuDays;
                            that.nextContinuIntegral = successRes.data.nextContinuIntegral;
                            Dialog.alert({
                                message: '签到成功！您已连续签到：'+that.cumulative+' 天,赠送积分：'+that.extPoint+',再连续签到'+that.needContinuDays+'天,可获得'+that.nextContinuIntegral+'积分'
                            }).then(() => {
                            });
                        }else{
                            Dialog.alert({
                                message: successRes.msg
                            }).then(() => {
                            });
                        }
                    })
            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;
    body {
        background-color: #f7f7f7;
    }

    .van-hairline--bottom::after {
        border-width: 0px;
    }

    .jump-order {

        .integral-header {
            background-color: @bule-thame;
            text-align: center;
            padding: 20px 0 60px;
            position: relative;
            .circle-text {
                height: 120px;
                color: #fff;
                position: relative;
                p {
                    font-size: 26px;
                    line-height: 100px;
                }
                span {
                    position: absolute;
                    bottom: 30px;
                    left: 35px;
                    font-size: 14px;
                }
            }
        }
        .integral-fun {
            background-color: #fff;
            text-align: center;
            padding: 60px 0 20px;
            &-item {
                padding: 10px 0;
                font-size: 14px;
                color: #333;
                i {
                    font-size: 24px;
                    padding: 6px 10px 4px;
                    color: #fff;
                    font-weight: 700;
                    display: inline-block;
                    background-color: #f56a00;
                    margin-bottom: 5px;
                    border-radius: 15px;
                }
            }
        }
        .integral-activity {
            background-color: #fff;
            text-align: center;
            margin-top: 10px;
            h5 {
                font-size: 16px;
                padding: 10px 10px;
                color: #333;

                text-align: left;
            }

        }
        .integral-hdf {
            position: absolute;
            bottom: -24px;
            width: 100%;
            padding: 0 40px;
            &-bg {
                background-color: #ffc107;
                padding: 8px 0;
                line-height: 32px;
                border-radius: 50px;
                color: #dc3545;
                text-align: center;
                font-size: 14px;
                div:first-child {
                    border-right: 1px solid #dc3545;
                }
            }
        }
    }
</style>


